module.exports = __webpack_public_path__ + "static/media/template2.a698c928.jpg";